"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleExtractor = exports.singleExtractor = exports.defaultExtractor = void 0;
var defaultExtractor = function (response) { return response; };
exports.defaultExtractor = defaultExtractor;
var singleExtractor = function (response) { return response.message; };
exports.singleExtractor = singleExtractor;
var multipleExtractor = function (response) { return response.messages; };
exports.multipleExtractor = multipleExtractor;
//# sourceMappingURL=ChatMessage.consts.js.map